import "./solicitudAnuladaEnCurso.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import "./../login/login.scss";
import Titulo from "../../components/atoms/titles/Titulo";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import "@fortawesome/fontawesome-free/scss/regular.scss";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
import { getPDFSolicitud } from "../../components/services/NivelCarreraService";
import {
  anularBorrador,
  getSolicitudReconocimientoByXwemprecnivcar2021,
} from "../../components/services/ReconocimientoNivelService";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import { SpinnerCircleMini } from "../../components/atoms/spinner/Spinner";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { formateoFechaConBarra } from "../../utils/Utils";

const SolicitudAnuladaEnCurso = (object) => {
  const [token] = useLocalStorage("token", "");
  const location = useLocation();
  const [show, setShow] = useState({
    mensaje: false,
  });
  const [showFeeback, setShowFeedback] = useState(false);

  const handleClose = (e) => {
    setShow(false);
  };

  let navigate = useNavigate();
  const [data] = useState({
    niep: "",
    nombre: "",
    apellido1: "",
    apellido2: "",
    domicilio: "",
    codigopostal: 0,
    localidad: "",
    provincia: "",
    tlf: "",
    correoE: "",
    a1: false,
    a2: true,
    a3: false,
    doe: [],
    estado: location?.state?.estado, //RECIBIR DE LA PAGINA ANTERIOR
  });

  const [solicitudObtenida, setSolicitudObtenida] = useState({});
  const [descargandoPDF, setDescargandoPDF] = useState(false);

  const visualizarPDFreconocimiento = () => {
    setShowFeedback(true);
    setDescargandoPDF(true);
    getPDFSolicitud(solicitudObtenida.xwemprecnivcar2021).then((data) => {
      
      if (!data.toString().startsWith("Error:")) {
        const file = new Blob([data], {
          type: "application/pdf",
        });
        if (file.size !== 0) {
          setDescargandoPDF(false);
          const fileURL = URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = `RN_${solicitudObtenida.niep}.pdf`;
          link.click();
          link.remove();
          setShowFeedback(false);
        } else {
          // setShowFeedback(true);
        }
      } else {
        // setShowFeedback(true);
      }
    });
  };
  const anularSolicitud = (codSol) => {
    anularBorrador(codSol).then((data) => {
      
    });
    // 
  };

  useEffect(() => {
    if (location?.state?.estado) {
      //TODO
    } else {
      navigate("/carrera");
    }

    if (location?.state?.id) {
      getSolicitudReconocimientoByXwemprecnivcar2021(location?.state?.id).then(
        (data) => {
          
          setSolicitudObtenida(data);
        }
      );
    }
  }, [location?.state?.estado, location?.state?.id, navigate, token]);

  

  function SolicitudAnuladaEnCurso() {
    return (
      <>
        <Header></Header>
        <div
          className="container d-flex flex-column min-vh-100 card mt-5"
          id="inicio"
          role="main" data-landmark-index="4"
        >
          <div className="my-auto">
            <div className="container-login fondo">
              <div className="tituloSolicitud">
                <Titulo titulo={"Anexo"} tipo={"tituloPagina"} />
                <div className="d-flex align-items-center flex-column">
                  <Titulo
                    titulo={
                      "SOLICITUD DE RECONOCIMIENTO DE NIVEL DE CARRERA PROFESIONAL HORIZONTAL (Ámbito Administración General)"
                    }
                    tipo={"tituloPagina subTituloPagina"}
                  />
                  {solicitudObtenida.fechaCreacion && solicitudObtenida.estado? (
                    location?.state?.estado ? (
                      <p className="p-3 text-success">{`${formateoFechaConBarra(
                        solicitudObtenida.fechaCreacion
                      )} | ${location?.state?.codigo} | ${
                        location?.state?.estado
                      }`}</p>
                    ) : (
                      <p className="p-3 text-third-1">
                        {solicitudObtenida.estado}
                      </p>
                    )
                  ) : <SpinnerCircleMini></SpinnerCircleMini>}
                </div>
                <div className="separador m-2"></div>
                <div className="infoSolicitud">
                  <div className="instrucciones">
                    <p className="my-3 mx-2">
                      Antes de cumplimentar y enviar esta solicitud, deberá leer
                      las instrucciones pinchando{" "}
                      <Link to="/instruccionesSolicitud" className="verde">
                        aquí
                      </Link>
                    </p>
                    <div className="separador m-2"></div>
                  </div>
                  <p className="textoInfo p-2">
                    Al amparo de lo previsto en el Decreto 127/2021, de 17 de
                    noviembre, por el que se regula la carrera profesional
                    horizontal y la evaluación del desempeño de los empleados
                    públicos que prestan sus servicios en la Administración
                    General de la Junta de Extremadura (DOE nº 225, de 23 de
                    noviembre de 2021) y conforme a lo dispuesto en el Plan de
                    Valoración para la progresión en el sistema de carrera
                    profesional horizontal vigente, el/la empleado/a público
                    cuyos datos se expresan a continuación, solicita el
                    reconocimiento de nivel de carrera profesional horizontal
                    que corresponda.
                  </p>
                </div>
                <div className="datosPersonales d-flex flex-column">
                  <div>
                    <div className="separador m-2"></div>
                    <div className="d-flex justify-content-between">
                      <Titulo
                        clases={"subSubTituloSolicitud p-2 fw-bold"}
                        tipo={"tituloCard noBg"}
                        titulo={"1. Datos personales"}
                      ></Titulo>
                    </div>
                    <div className="separador m-2"></div>
                  </div>

                  <div className="formulario">
                    <>
                      <div className="datosSolAnuladaEnCurso p-2">
                        {datosSolicitud("DNI", solicitudObtenida.niep, "dniDP")}
                        {datosSolicitud(
                          "Nombre",
                          solicitudObtenida.nombre,
                          "nombreDP"
                        )}
                        {datosSolicitud(
                          "Primer Apellido",
                          solicitudObtenida.apellido1,
                          "ape1DP"
                        )}
                        {datosSolicitud(
                          "Segundo Apellido",
                          solicitudObtenida.apellido2,
                          "ape2DP"
                        )}
                        {datosSolicitud(
                          "Domicilio",
                          solicitudObtenida.domicilio,
                          "domicilioDP"
                        )}
                        <div className="localidadCPDP m-2">
                          <p>Localidad:</p>
                          <p className="fw-bold">
                            {solicitudObtenida.localidad}
                          </p>
                          <p>CP:</p>
                          <p className="fw-bold">
                            {solicitudObtenida.codigopostal}
                          </p>
                        </div>
                        {datosSolicitud(
                          "Provincia",
                          solicitudObtenida.provincia,
                          "provinciaDP"
                        )}
                        {datosSolicitud(
                          "Teléfono de contacto",
                          solicitudObtenida.telefonocontacto,
                          "tlfContactoDP"
                        )}
                        {datosSolicitud(
                          "Correo electrónico de contacto",
                          solicitudObtenida.correoE,
                          "emailDP"
                        )}
                      </div>
                    </>

                    <div className="relacionMeritos">
                      <div className="separador m-2"></div>
                      <Titulo
                        clases={"subSubTituloSolicitud p-2 fw-bold"}
                        tipo={"tituloCard noBg"}
                        titulo={
                          "2. Relación de méritos para alcanzar la puntuación mínima necesaria para superar el proceso de valoración:"
                        }
                      ></Titulo>
                      <div className="separador m-2"></div>
                      <div className="meritosComprobar">
                        <div className="separador m-2"></div>
                        <Titulo
                          clases={"subSubTituloSolicitud p-2 fw-bold"}
                          tipo={"tituloCard noBg"}
                          titulo={"2.A) Méritos a comprobar de oficio:"}
                        ></Titulo>
                        <div className="separador m-2"></div>
                        <div className="p-2">
                          <>
                            <i
                              className={
                                "fa-solid " +
                                (solicitudObtenida.a1
                                  ? "fa-square-check"
                                  : "fa-square") +
                                " text-success"
                              }
                            ></i>{" "}
                            A.1- Formación continua recibida y docencia
                            impartida en la Escuela de Administración Pública de
                            Extremadura (EAP).
                            <p>
                              Formación certificada por la EAP que se deberá
                              marcar si el/la solicitante quiere que se le
                              valore.
                            </p>
                            <p className="fw-bold">
                              NO SE APORTARÁ DOCUMENTACIÓN.
                            </p>
                            <i
                              className={
                                "fa-solid " +
                                (solicitudObtenida.a2
                                  ? "fa-square-check"
                                  : "fa-square") +
                                " text-success"
                              }
                            ></i>{" "}
                            A.2- Puestos de trabajo de especial desempeño.
                            <p>
                              Son aquellos puestos de trabajo que reunen alguna
                              de las circunstancias establecidas en el Plan de
                              Valoración.
                            </p>
                            <p className="fw-bold">
                              NO SE APORTARÁ DOCUMENTACIÓN.
                            </p>
                            <i
                              className={
                                "fa-solid " +
                                (solicitudObtenida.a3
                                  ? "fa-square-check"
                                  : "fa-square") +
                                " text-success"
                              }
                            ></i>{" "}
                            A.3- Participación en órganos de selección y/o
                            provisión del personal de la Administración de la
                            Junta de Extremadura.
                            <p>
                              Se valorará la participación en calidad de
                              presidente/a, secretario/a, vocal o asesor/a de
                              los órganos de selección y provisión de la
                              Administración General de la Junta de Extremadura.
                              La persona solicitante deberá indicar, en su caso,
                              el DOE de su nombramiento o de la publicación de
                              la convocatoria de provisión.
                            </p>
                            <p>
                              La persona solicitante deberá indicar, en su caso,
                              el DOE de su nombramiento o de la publicación de
                              la convocatoria de provisión.
                            </p>
                            <p className="fw-bold">
                              NO SE APORTARÁ DOCUMENTACIÓN.
                            </p>
                          </>
                          <div className="d-flex flex-column">
                            {solicitudObtenida?.doe?.map((input) => (
                              <>
                                <div className="d-flex">
                                  <p>DOE:</p>
                                  <p className="fw-bold">{input.value}</p>
                                </div>
                              </>
                            ))}
                          </div>
                        </div>
                        <div className="meritosAcreditados">
                          <div className="separador m-2"></div>
                          <Titulo
                            clases={"subSubTituloSolicitud p-2 fw-bold"}
                            tipo={"tituloCard noBg"}
                            titulo={
                              "2.B)  Méritos que deben ser acreditados por el/la interesado/a:"
                            }
                          ></Titulo>
                          <div className="separador m-2"></div>
                          <p className="textoInfo p-2">
                            Si la persona solicitante cumplimenta alguno de
                            estos apartados, deberá describir el mérito alegado,
                            imprimir esta solicitud y enviarla, junto con los
                            correspondientes certificados acreditativos, a la
                            Dirección General de Función Pública, a través de
                            alguno de los registros administrativos habilitados
                            al efecto. En el caso de la formación continua y
                            docencia el certificado deberá indicar el número de
                            créditos/horas, en caso contrario, no serán objeto
                            de valoración.
                          </p>
                          <div className="formacion">
                            <div className="separador m-2"></div>
                            <Titulo
                              clases={"subSubTituloSolicitud p-2 fw-bold"}
                              tipo={"tituloCard noBg"}
                              titulo={
                                "B.1.- Formación (no impartida por la EAP):"
                              }
                            ></Titulo>
                            <div className="separador m-2"></div>
                            <div className="d-flex flex-column p-2">
                              {solicitudObtenida?.formacion?.map((input) => (
                                <>
                                  <div className="d-flex">
                                    <p className="fw-bold">{input.value}</p>
                                  </div>
                                </>
                              ))}
                            </div>
                          </div>
                          <div className="trasnferencia">
                            <div className="separador m-2"></div>
                            <Titulo
                              clases={"subSubTituloSolicitud p-2 fw-bold"}
                              tipo={"tituloCard noBg"}
                              titulo={
                                "B.2.- Transferencia, innovacion y difusión de conocimientos:"
                              }
                            ></Titulo>
                            <div className="separador m-2"></div>
                            <div className="d-flex flex-column p-2">
                              {solicitudObtenida?.transferencia?.map(
                                (input) => (
                                  <>
                                    <div className="d-flex">
                                      <p className="fw-bold">{input.value}</p>
                                    </div>
                                  </>
                                )
                              )}
                            </div>
                            <div className="participacion">
                              <div className="separador m-2"></div>
                              <Titulo
                                clases={"subSubTituloSolicitud p-2 fw-bold"}
                                tipo={"tituloCard noBg"}
                                titulo={
                                  "B.3.- Participación en tribunales de las corporaciones locales en calidad de representante de la Administración General de la Junta de Extremadura."
                                }
                              ></Titulo>
                              <div className="separador m-2"></div>
                              <p className="textoInfo p-2">
                                La persona solicitante deberá indicar el BOP de
                                su nombramiento.
                              </p>
                              <div className="d-flex flex-column p-2">
                                {solicitudObtenida?.participacion?.map(
                                  (input) => (
                                    <>
                                      <div className="d-flex">
                                        <p className="fw-bold">{input.value}</p>
                                      </div>
                                    </>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="footer">
                          <p className="p-2">
                            En cumplimiento de lo dispuesto en la Ley Orgánica
                            3/2018, de 5 de diciembre, de protección de datos
                            personales y garantía de los derechos digitales, la
                            Consejería de Hacienda y Administración Pública le
                            informa que los datos de carácter personal recogidos
                            en esta solicitud van a ser tratados con la
                            finalidad de que le sea reconocido el nivel de
                            carrera profesional horizontal que corresponda. El
                            responsable del tratamiento de estos datos será la
                            Consejería de Hacienda y Administración Pública. Las
                            personas interesadas podrán ejercitar los derechos
                            de acceso, rectificación, cancelación, supresión,
                            limitación del tratamiento y oposición establecidos
                            en los artículos 12 a 18 de la referida Ley
                            Orgánica, mediante escrito dirigido a la Dirección
                            General de Función Pública (Avda. Valhondo s/n,
                            Edificio III Milenio, Módulo 1- 1ª planta. 06800 -
                            MÉRIDA)
                          </p>
                          <div className="direccion d-flex flex-column align-items-center m-2 text-center">
                            <p>DIRECCIÓN GENERAL DE FUNCIÓN PÚBLICA</p>
                            <p className="text-center">
                              Avda. Valhondo, s/n Edificio III Milenio - Módulo
                              1 - 1ª Planta - 06800 Mérida
                            </p>
                          </div>
                        </div>
                        <div className="d-flex mb-2 flex-sm-row flex-column">
                          <button
                            id="cancelarSolicitudAnualadaEnCurso"
                            className="btnRed rounded m-2"
                            type="button"
                            onClick={() =>
                              setShow({
                                mensaje: true,
                                content:
                                  "¿Deseas cancelar la visualización de la solicitud?",
                                tipo: "tituloModal",
                                aviso: true,
                                destinoAviso: "/carrera",
                              })
                            }
                          >
                            <i className="fa-solid fa-cancel"></i> Cancelar
                          </button>
                          <button
                            id="imprimirSolicitudAnualadaEnCurso"
                            className="btn m-2"
                            type="submit"
                            onClick={visualizarPDFreconocimiento}
                            disabled={showFeeback}
                          >
                            {!descargandoPDF ? (
                              <>
                                <i className="fa-solid fa-download"></i>{" "}
                                Descargar
                              </>
                            ) : (
                              <>
                                <div className="d-flex justify-content-center">
                                  <SpinnerCircleMini
                                    clases={"background-border"}
                                  ></SpinnerCircleMini>
                                </div>
                              </>
                            )}
                          </button>
                          {data.estado === "EN CURSO" ? (
                            <>
                              <button
                                id="anularSolicitudAnualadaEnCurso"
                                className="btnRed rounded m-2"
                                type="button"
                                onClick={() =>
                                  setShow({
                                    mensaje: true,
                                    content: "¿Deseas anular la solicitud?",
                                    tipo: "tituloModal",
                                    aviso: true,
                                    destinoAviso: "/carrera",
                                  })
                                }
                              >
                                <i className="fa-solid fa-xmark"></i> Anular
                              </button>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {show.mensaje ? (
            <ModalMensajes
              show={show.mensaje}
              handleClose={handleClose}
              titulo={show.content}
              tipo={show.tipo}
              aviso={show.aviso}
              destinoAviso={show.destinoAviso}
              funcion={anularSolicitud}
              valorFuncion={location?.state?.id}
              destinoCerrar={show?.destinoCerrar}
            ></ModalMensajes>
          ) : null}
        </div>
        <Footer></Footer>
      </>
    );
  }

  return <>{SolicitudAnuladaEnCurso()}</>;
};

export default memo(SolicitudAnuladaEnCurso);
function datosSolicitud(text, data, clases) {
  return (
    <div className={clases + " m-2"}>
      <p>{text}:</p>
      <p className="fw-bold">{data}</p>
    </div>
  );
}
